import { createSelector } from '@reduxjs/toolkit';
import { DEFAULT_GAME_LANGUAGE } from '../../../../Utils/Constants';
import { storeSelector } from '../../Global/StoreSelector';

const gameLanguage = createSelector(
  storeSelector,
  (state) => state.user.currentUser?.settings.smoLanguage ?? DEFAULT_GAME_LANGUAGE
);

export default {
  gameLanguage
};
